'use client';

import BlogIndexContent from '@/components/Desktop/Blog/BlogIndexContent';
import BlogIndexMobile from '@/components/Mobile/Blog/BlogIndexMobile';
import { useIsMobile } from '@/components/DeviceContext';
import type { BlogPostModel } from '@/lib/models/BlogPost';

interface Props {
  posts: BlogPostModel[];
}

export default function BlogIndexPageContent({ posts }: Props) {
  const isMobile = useIsMobile();
  return isMobile
    ? <BlogIndexMobile posts={posts} />
    : <BlogIndexContent posts={posts} />;
}
